import { buildImportPrompt } from './prompts';

export type Provider = 'chatgpt' | 'claude';

type ProviderConfig = {
	id: Provider;
	label: string;
	chatUrl: string;
	logoColor: string;
	chipBg: string;
};

export const PROVIDERS: Record<Provider, ProviderConfig> = {
	chatgpt: {
		id: 'chatgpt',
		label: 'ChatGPT',
		chatUrl: 'https://chatgpt.com/',
		logoColor: '#0D0D0D',
		chipBg: '#F2F1ED',
	},
	claude: {
		id: 'claude',
		label: 'Claude',
		chatUrl: 'https://claude.ai/new',
		logoColor: '#C15F3C',
		chipBg: '#F7EDE6',
	},
};

export type PromptVars = {
	websiteUrl: string;
	instagramHandle: string;
};

/**
 * Copy a provider's import prompt to the clipboard. Single source of truth for
 * "build prompt + write clipboard", called from the provider card (Screen 1)
 * and the copy-again / reopen buttons (Screen 2). Must run synchronously inside
 * a user-gesture handler; clipboard rejection is swallowed.
 */
export const copyImportPrompt = (
	provider: Provider,
	vars: PromptVars,
): void => {
	const text = buildImportPrompt(provider, vars);
	if (navigator.clipboard?.writeText) {
		void navigator.clipboard.writeText(text).catch(() => {});
	}
};

/** Open a provider's chat in a centered popup window (matches openAuthPopup). */
export const openProviderPopup = (url: string): void => {
	const width = 560;
	const height = 720;
	const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
	const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);
	window.open(
		url,
		'beacon_ai_import',
		`width=${width},height=${height},left=${left},top=${top}`,
	);
};
